<template>
  <Tooltip class="ml-[9px]">
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="8" fill="#917DFF" />
      <path
        d="M5.6001 5.79763C5.6001 5.32087 5.82121 4.86364 6.2148 4.52651C6.60839 4.18939 7.14221 4 7.69883 4H8.29847C8.85509 4 9.38892 4.18939 9.7825 4.52651C10.1761 4.86364 10.3972 5.32087 10.3972 5.79763C10.4193 6.18667 10.3143 6.57235 10.098 6.89657C9.88167 7.22079 9.5658 7.466 9.19793 7.59527C8.83007 7.76762 8.5142 8.09456 8.2979 8.52686C8.08159 8.95915 7.97657 9.47339 7.99865 9.99211"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.99854 12.3889V12.3949"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <template #popper>
      <div class="max-w-xs leading-[1.4]" v-html="tip"></div>
    </template>
  </Tooltip>
</template>

<script setup lang="ts">
import { Tooltip } from "floating-vue";
import "floating-vue/dist/style.css";
  defineProps({
    tip: {
      type: String,
      default: "",
    },
  });
</script>
